import { useEffect } from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

function About() {
  useEffect(() => {
    // FAQ accordion functionality if needed
  }, []);

  return (
    <>
      <Header />
      
      <section className="about-hero-section">
        <div className="container">
          <h1 className="about-hero-title">
            <span className="about-title-line-1">I'M ANSH</span>
            <br/>
            <span className="about-title-line-2">CHOPRA</span>
          </h1>
          
          <div className="about-hero-content">
            <div className="about-hero-image">
              <img src="/assets/pfp.jpeg" alt="Ansh Chopra" />
            </div>
            
            <div className="about-hero-text">
              <p className="about-description">
                As a dedicated UI/UX designer and Webflow developer, I specialize in creating visually stunning and user-friendly websites. My passion lies in crafting seamless digital experiences that blend innovative design with intuitive functionality.
              </p>
              
              <div className="social-links">
                <a href="https://www.linkedin.com/in/anshchopra26/" target="_blank" rel="noopener noreferrer" className="social-link">LinkedIn</a>
                <a href="https://drive.google.com/file/d/1iKpM8X_K9XL1n_9z4VjmfrP6CrCsnZzU/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="social-link">Resume</a>
                <a href="https://drive.google.com/file/d/1FiHJFm0p5etaPDE3h3g-dsKTAGkeJ0xY/view?usp=sharing" target="_blank" rel="noopener noreferrer" className="social-link">UI/UX Resume</a>
                <a href="https://www.instagram.com/anshchopra_21/" target="_blank" rel="noopener noreferrer" className="social-link">Instagram</a>
              </div>
              
              <a href="/contact" className="about-cta">
                Contact Now <span>→</span>
              </a>
            </div>
          </div>

          <div className="about-clients-section">
            <div className="clients-title">Featured Clients</div>
            <div className="clients-grid">
              <div className="clients-scroll">
                <div className="client-item"><span>&#10038;</span> Jungleworks</div>
                <div className="client-item"><span>&#10038;</span> Flash Delivery</div>
                <div className="client-item"><span>&#10038;</span> Solo Beauty</div>
                <div className="client-item"><span>&#10038;</span> Inamigos</div>
                <div className="client-item"><span>&#10038;</span> Nayepankh</div>
                <div className="client-item"><span>&#10038;</span> Alen Wokens</div>
                <div className="client-item"><span>&#10038;</span> Jungleworks</div>
                <div className="client-item"><span>&#10038;</span> Flash Delivery</div>
                <div className="client-item"><span>&#10038;</span> Solo Beauty</div>
                <div className="client-item"><span>&#10038;</span> Inamigos</div>
                <div className="client-item"><span>&#10038;</span> Nayepankh</div>
                <div className="client-item"><span>&#10038;</span> Alen Wokens</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="education-section">
        <div className="container">
          <div className="education-container">
            <div className="education-left">
              <h2 className="education-title">EDUCATION</h2>
            </div>

            <div className="education-list">
              <div className="education-item">
                <div className="education-year">2022-2026</div>
                <div className="education-content">
                  <h3 className="education-degree">Bachelor of Technology</h3>
                  <p className="education-school">Chandigarh Group of College</p>
                </div>
              </div>

              <div className="education-item">
                <div className="education-year">2021-2022</div>
                <div className="education-content">
                  <h3 className="education-degree">12th (PCM)</h3>
                  <p className="education-school">KC International School</p>
                </div>
              </div>

              <div className="education-item">
                <div className="education-year">2019-2020</div>
                <div className="education-content">
                  <h3 className="education-degree">10th (Science)</h3>
                  <p className="education-school">KC International School</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="awards-section">
        <div className="container">
          <div className="awards-container">
            <div className="awards-left">
              <h2 className="awards-title">AWARDS</h2>
            </div>

            <div className="awards-list">
              <div className="award-item">
                <div className="award-content">
                  <h3 className="award-name">National level skating winner</h3>
                </div>
                <div className="award-year">2020</div>
              </div>

              <div className="award-item">
                <div className="award-content">
                  <h3 className="award-name">State level olympic winner</h3>
                </div>
                <div className="award-year">2019</div>
              </div>

              <div className="award-item">
                <div className="award-content">
                  <h3 className="award-name">Interschool football champion</h3>
                </div>
                <div className="award-year">2017</div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-section">
        <div className="container">
          <div className="why-choose-container">
            <div className="why-choose-left">
              <h2 className="why-choose-title">WHY CHOOSE ME?</h2>
            </div>

            <div className="why-choose-list">
              <div className="why-choose-item">
                <div className="why-choose-number">(01)</div>
                <div className="why-choose-content">
                  <h3 className="why-choose-name">Creative ideas</h3>
                  <p className="why-choose-description">
                    Creative, user-focused designer delivering intuitive, visually engaging experiences that balance aesthetics, functionality, and business goals through thoughtful design solutions.
                  </p>
                </div>
              </div>

              <div className="why-choose-item">
                <div className="why-choose-number">(02)</div>
                <div className="why-choose-content">
                  <h3 className="why-choose-name">Expert in tools</h3>
                  <p className="why-choose-description">
                    Expert in Figma, Canva, VN, and Pencil, creating polished designs, engaging visuals, and seamless user experiences with creative precision.
                  </p>
                </div>
              </div>

              <div className="why-choose-item">
                <div className="why-choose-number">(03)</div>
                <div className="why-choose-content">
                  <h3 className="why-choose-name">Clean & minimal design</h3>
                  <p className="why-choose-description">
                    Clean and minimal design approach focused on clarity, simplicity, and usability, creating elegant interfaces that enhance user experience effectively.
                  </p>
                </div>
              </div>

              <div className="why-choose-item">
                <div className="why-choose-number">(04)</div>
                <div className="why-choose-content">
                  <h3 className="why-choose-name">User-friendly design</h3>
                  <p className="why-choose-description">
                    User-friendly design focused on intuitive navigation, seamless interactions, and clear visual hierarchy, ensuring smooth, enjoyable experiences for every user.
                  </p>
                </div>
              </div>

              <div className="why-choose-item">
                <div className="why-choose-number">(05)</div>
                <div className="why-choose-content">
                  <h3 className="why-choose-name">Proven results</h3>
                  <p className="why-choose-description">
                    Proven results through impactful design solutions that improve usability, elevate brand presence, and deliver measurable value across digital products.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="working-process-section">
        <div className="container">
          <div className="working-process-container">
            <div className="working-process-left">
              <h2 className="working-process-title">WORKING PROCESS</h2>
            </div>

            <div className="working-process-list">
              <div className="process-item">
                <div className="process-step">[STEP-1]</div>
                <div className="process-content">
                  <h3 className="process-name">Send email</h3>
                  <p className="process-description">
                    Share your project idea and goals — a quick introduction to start the collaboration.
                  </p>
                </div>
              </div>

              <div className="process-item">
                <div className="process-step">[STEP-2]</div>
                <div className="process-content">
                  <h3 className="process-name">Meet online</h3>
                  <p className="process-description">
                    We discuss requirements, vision, and user needs to align the design direction perfectly.
                  </p>
                </div>
              </div>

              <div className="process-item">
                <div className="process-step">[STEP-3]</div>
                <div className="process-content">
                  <h3 className="process-name">Price estimation</h3>
                  <p className="process-description">
                    Clear scope, transparent pricing, and timeline planning before we begin the design process.
                  </p>
                </div>
              </div>

              <div className="process-item">
                <div className="process-step">[STEP-4]</div>
                <div className="process-content">
                  <h3 className="process-name">Work together</h3>
                  <p className="process-description">
                    Design, feedback, and refinement — turning ideas into a polished, user-focused final product.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </>
  );
}

export default About;
